<div class="row spacer-top spacer-bottom examfield">
  <!-- Biopsie -->
  <div class="col-xs-12 col-sm-6 spacer-top">

    <label>Bezeichnung der Probe <span ng-bind="vm.field.label"></span></label>
    <tags-input ng-model="vm.field.avalues" data-hook="biopsyname"
                display-property="name"
                placeholder="Tippen zum Vervollständigen"
                add-on-comma="false"
                min-length="1"
                tabindex="0"
                enable-editing-last-tag="true"
                replace-spaces-with-dashes="false"
                ng-blur="vm.save()"
                template="tag-template">
      <auto-complete source="vm.loadBValues($query)"
                     min-length="0"
                     load-on-focus="true"
                     load-on-down-arrow="true"
                     load-on-empty="true"
                     max-results-to-show="32"
                     select-first-match="false"
                     template="autocomplete-template"></auto-complete>
    </tags-input>
  </div>
  
  <!-- Ergebnis -->
  <div class="col-xs-12 col-sm-6 spacer-top">
    <label>Ergebnis</label>
    <input class="form-control" ng-model="vm.field.result" ng-blur="vm.save()" placeholder="Ergebnis der Biopsie">
  </div>
</div>

<!-- tag templates -->
<script type="text/ng-template" id="tag-template">
  <div class="tag-template">
    <div class="right-panel">
      <span>{{$getDisplayText()}}</span>
      <a class="remove-button" ng-click="$removeTag()">&#10006;</a>
    </div>
  </div>
</script>


<script type="text/ng-template" id="autocomplete-template">
  <div class="autocomplete-template">
    <div>
      <span ng-bind-html="$highlight($getDisplayText())">{{name}}</span>
    </div>
  </div>
</script>
